import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { format } from "date-fns";
import { Chip, formatDateString } from "../../../helpers/general";
import { tdStyle, thStyle } from "../../../helpers/constants";

interface Props {
  items: PointsHistory[];
}

export default function PointsHistoryTable({ items }: Props) {
  return (
    <CTable responsive hover align="middle" className="mb-0">
      <CTableHead>
        <CTableRow>
          <CTableHeaderCell scope="col" style={thStyle}>
            Date / Heure
          </CTableHeaderCell>
          <CTableHeaderCell scope="col" style={thStyle}>
            Points
          </CTableHeaderCell>
          <CTableHeaderCell scope="col" style={thStyle}>
            Type
          </CTableHeaderCell>
          <CTableHeaderCell scope="col" style={thStyle}>
            Référence
          </CTableHeaderCell>
          <CTableHeaderCell scope="col" style={thStyle}>
            Description
          </CTableHeaderCell>
        </CTableRow>
      </CTableHead>

      <CTableBody>
        {items.map((item) => (
          <CTableRow key={item.id}>
            {/* Date */}
            <CTableDataCell style={tdStyle}>
              <div className="fw-semibold text-capitalize">
                {formatDateString(item.createdAt)}
              </div>
              <div className="text-muted" style={{ fontSize: 12 }}>
                {format(new Date(item.createdAt), "HH:mm")}
              </div>
            </CTableDataCell>

            {/* Points */}
            <CTableDataCell style={tdStyle}>
              <Chip tone={item.points > 0 ? "success" : "danger"}>
                {item.points > 0 ? `+${item.points}` : item.points}
              </Chip>
            </CTableDataCell>

            {/* Type */}
            <CTableDataCell style={tdStyle}>
              <Chip tone={item.source === "RIDE" ? "neutral" : "warning"}>
                {item.source}
              </Chip>
            </CTableDataCell>

            {/* Reference */}
            <CTableDataCell style={tdStyle}>
              {item.booking?.title ? (
                <span className="fw-semibold text-capitalize">
                  {item.booking.title}
                </span>
              ) : (
                <span className="text-muted">—</span>
              )}
            </CTableDataCell>

            {/* Description */}
            <CTableDataCell style={tdStyle}>
              {item.description || <span className="text-muted">—</span>}
            </CTableDataCell>
          </CTableRow>
        ))}
      </CTableBody>
    </CTable>
  );
}
